"use client";

import type { FC } from "react";
import { Flex, useThemeSlot } from "@huub-web/ui";

import { DefaultPageHeading } from "../../components/DefaultPageHeading/DefaultPageHeading";

export type OrientationHeadingTemplateProps = Record<string, never>;

export const OrientationHeadingTemplate: FC<
  OrientationHeadingTemplateProps
> = ({ ref }) => {
  const PageHeading = useThemeSlot({
    key: "pageHeading",
    defaultComponent: DefaultPageHeading,
  });

  return (
    <Flex ref={ref} direction="column" gap="s">
      <PageHeading scope="orientation" />
    </Flex>
  );
};
